// extracted by mini-css-extract-plugin
export default {"List":"AUfJtEL9Zrpxwnw3i9vq"};